import React, { lazy, Suspense } from 'react';
import { isOnServer, mergeClassNames } from '../../utils';
import { CloseButton } from '../generic/Button';
import Modal from '../generic/Modal';
import TransitionReveal from '../generic/TransitionReveal';
import styles from './index.module.scss';

const ContactForm = lazy(() => import('contactform'));

export default function ContactFormView({
  closeFn = () => null,
  backButton = <Close closeFn={closeFn} />,
  isVisible = true,
  standalone = false,
  className = null,
  style = null,
}) {
  return (
    <TransitionReveal
      isVisible={isVisible}
      initialTranslate={{ y: '100vh' }}
      className={mergeClassNames([
        styles.contactFormOuter,
        standalone ? styles.contactFormStandalone : null,
        className,
      ])}
      style={style}
    >
      <Modal
        closeCallback={closeFn}
        className={styles.contactFormModal}
        portal={standalone}
        lockBodyScroll={standalone}
        fixed
      >
        <TransitionReveal
          isVisible={isVisible}
          initialTranslate={{ y: '100vh' }}
          className={mergeClassNames([
            styles.contactFormOuter,
            standalone ? styles.contactFormStandalone : null,
            className,
          ])}
          style={style}
        >
          {!isOnServer && (
            <Suspense fallback={<div />}>
              <ContactForm backButton={backButton} className={styles.contactForm} closeFn={closeFn} />
            </Suspense>
          )}
        </TransitionReveal>
      </Modal>
    </TransitionReveal>
  );
}

function Close({ closeFn }) {
  return (
    <CloseButton clickHandler={closeFn} isIconRight>
      Close
    </CloseButton>
  );
}
